import React, { useEffect, useState } from "react";
import { Motorista } from "../../../Models/Cadastros/Motorista/Motorista";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import DropDownBooleanComponent from "../../../Components/Forms/DropDownBooleanComponent";
import axios from "axios";
// import MotoristaNaoConformidadePartial from "./MotoristaNaoConformidadePartial";

const MotoristaDadosTab = (props: any) => {
    const [motorista, setMotorista] = useState<any>(new Motorista());
    const [estados, setEstados] = useState<any[]>([]);

    const estadoCivilOptions =
        [{
            "id": "1",
            "descricao": "NÃO INFORMADO"
        }, {
            "id": "2",
            "descricao": "CASADO"
        }, {
            "id": "3",
            "descricao": "SOLTEIRO"
        }, {
            "id": "4",
            "descricao": "DIVORCIADO"
        }, {
            "id": "5",
            "descricao": "UNIÃO ESTÁVEL"
        }, {
            "id": "6",
            "descricao": "VIÚVO"
        }];

    const vinculoOptions = [{
        "id": "1",
        "descricao": "FROTA"
    }, {
        "id": "2",
        "descricao": "AGREGADO"
    }, {
        "id": "3",
        "descricao": "CARRETEIRO"
    }];

    const cnhCateoriaOptions = [{
        "id": "1",
        "descricao": "A"
    }, {
        "id": "2",
        "descricao": "AB"
    }, {
        "id": "3",
        "descricao": "AC"
    }, {
        "id": "4",
        "descricao": "AD"
    }, {
        "id": "5",
        "descricao": "AE"
    }, {
        "id": "6",
        "descricao": "B"
    }, {
        "id": "7",
        "descricao": "C"
    }, {
        "id": "8",
        "descricao": "D"
    }, {
        "id": "9",
        "descricao": "E"
    }];

    const escolaridadeOptions = [{
        "id": "1",
        "descricao": "ALFABETIZADO"
    }, {
        "id": "2",
        "descricao": "FUNDAMENTAL"
    }, {
        "id": "3",
        "descricao": "ENSINO MÉDIO"
    }, {
        "id": "4",
        "descricao": "SUPERIOR"
    }];

    useEffect(() => {
        setMotorista(props.motorista);
    }, [props.motorista]);

    useEffect(() => {
        (async () => {
            let responseEstados: any = await axios.get('buscaEstados');
            setEstados(responseEstados.data);
        })();
    }, []);

    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Nome"
                    field='nome'
                    model={motorista} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="CPF"
                    field='cpf'
                    model={motorista} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="RG"
                    field='rg'
                    model={motorista} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Orgão emis./UF"
                    field='orgao_emissor'
                    model={motorista} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Estado civil'
                    required
                    options={estadoCivilOptions}
                    valueField='id'
                    textField='descricao'
                    model={motorista}
                    modelField='estado_civil' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Escolaridade'
                    required
                    options={escolaridadeOptions}
                    valueField='id'
                    textField='descricao'
                    model={motorista}
                    modelField='escolaridade' />
            </div>

            <div className="col-md-6 mb-3">
                <TextFieldComponent
                    required
                    label="Nome da Mãe"
                    field='nome_da_mae'
                    model={motorista} />
            </div>
            
            {/* padrão cnh vencida         */}
            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='CNH'
                    model={motorista}
                    modelField='email_cnh' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Categoria'
                    required
                    options={cnhCateoriaOptions}
                    valueField='id'
                    textField='descricao'
                    model={motorista}
                    modelField='cnh_categoria' />
            </div>

            <div className="col-md-6 mb-3">
                
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="CEP"
                    field='cep'
                    model={motorista} />
            </div>
            
            <div className="col-md-5 mb-3">
                <TextFieldComponent
                    required
                    label="Rua"
                    field='rua'
                    model={motorista} />
            </div>
            
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Número"
                    field='numero'
                    model={motorista} />
            </div>
            
            <div className="col-md-4 mb-3">
                <TextFieldComponent
                    required
                    label="Complemento"
                    field='complemento'
                    model={motorista} />
            </div>
            
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Bairro"
                    field='bairro'
                    model={motorista} />
            </div>
            
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Cidade"
                    field='cidade'
                    model={motorista} />
            </div>

            <div className="col-md-2 mb-3">
                <DropDownListComponent
                    label='Uf'
                    required
                    options={estados}
                    valueField='id'
                    textField='sigla'
                    model={motorista}
                    modelField='end_uf_id' />
            </div>
                        
            <div className="col-md-4 mb-3">
                <TextFieldComponent
                    label="Tel. Fixo"
                    field='tel_fixo'
                    model={motorista} />
            </div>
            
            <div className="col-md-4 mb-3">
                <TextFieldComponent
                    label="Celular"
                    field='celular'
                    model={motorista} />
            </div>
            
            <div className="col-md-4 mb-3">
                <TextFieldComponent
                    label="Nextel ID"
                    field='nextel_id'
                    model={motorista} />
            </div>
            
            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Vínculo'
                    required
                    options={vinculoOptions}
                    valueField='id'
                    textField='descricao'
                    model={motorista}
                    modelField='vinculo' />
            </div>
            
            <div className="col-md-9 mb-9">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Empresa'
                    urlApi='buscaEmpresas'
                    valueField='id'
                    textField='nome_completo'
                    model={motorista}
                    modelField='empresa_id' />
            </div>
            
        </div>
    );
}

export default MotoristaDadosTab;